import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { adminApi, errorMessage } from "../../lib/api";

export const TelegramDialog = ({ open, onClose }) => {
  const [s, setS] = useState(null);
  const load = useCallback(() => adminApi.get("/admin/telegram").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { if (open) load(); }, [open, load]);
  const run = (path, msg) => adminApi.post(path).then(() => { if (msg) toast.success(msg); load(); }).catch((e) => toast.error(errorMessage(e)));
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="telegram-dialog" className="rounded-none border-white/10 bg-[#0F172A] text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white">Telegram alerts</DialogTitle>
          <DialogDescription className="text-slate-400">Every site activity is sent to your Telegram through @{s?.bot}.</DialogDescription>
        </DialogHeader>
        {s && (s.connected ? (
          <div className="space-y-3">
            <p data-testid="telegram-status" className="text-emerald-300">Connected to {s.chat_name}</p>
            <button onClick={() => run("/admin/telegram/test", "Test message sent")} data-testid="telegram-test-button" className="bg-[#229ED9] px-4 py-2 text-sm font-semibold text-white">Send test message</button>
            <button onClick={() => run("/admin/telegram/code")} data-testid="telegram-reconnect-button" className="ml-2 border border-white/15 px-4 py-2 text-sm">Connect a different chat</button>
          </div>
        ) : null)}
        {s && (!s.connected || s.connect_code) && (
          <div className="space-y-3 text-sm">
            {s.connect_code ? (
              <>
                <p>1. Open <a href={`https://t.me/${s.bot}?start=${s.connect_code}`} target="_blank" rel="noreferrer" data-testid="telegram-bot-link" className="text-sky-300 underline">@{s.bot}</a> and press Start, or send:</p>
                <p data-testid="telegram-connect-code" className="bg-[#0B1120] px-3 py-2 font-mono text-lg text-orange-300">/start {s.connect_code}</p>
                <p>2. Then click Check:</p>
                <button onClick={() => run("/admin/telegram/connect", "Telegram connected")} data-testid="telegram-check-button" className="bg-[#229ED9] px-4 py-2 font-semibold text-white">Check</button>
              </>
            ) : (
              <button onClick={() => run("/admin/telegram/code")} data-testid="telegram-generate-button" className="bg-[#229ED9] px-4 py-2 font-semibold text-white">Connect Telegram</button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
